import type { ReactElement } from 'react'

import { SectionTitle } from '@/components/elements/SectionTitle'
import { Spacer } from '@/components/elements/Spacer'
import { TitleLayout } from '@/components/layout'
import { Head } from '@/components/layouts/Head'
import { Layout } from '@/components/layouts/Ir'
import { Paragraph } from '@/components/layouts/Ir/Paragraph'
import { PDFList } from '@/components/layouts/Ir/PDFList'

const pdfList = [
  {
    id: 'af28c402-0dff-4855-86ea-77181fa11dab',
    fileName: '定款',
    filePath: 'https://storage.googleapis.com/p_62df6d7ecf43187b7e0b68b2/e95ddf51-af23-4e07-b783-b854e823f62c/TRIAL_articles_of_incorporation_240927.pdf',
  },
  {
    id: '2c873a08-d960-4347-a808-7fadb98bbb9b',
    fileName: '株式取扱規程',
    filePath: 'https://storage.googleapis.com/p_62df6d7ecf43187b7e0b68b2/d03257b0-7634-4193-891c-5f174075af8d/TRIAL_share_handling_regulations_230412.pdf',
  },
]

export const ArticlesPage = () => {
  return (
    <Layout>
      <SectionTitle
        titleText="Articles of Incorporation and Share Handling Regulations"
        subTitleText="定款・株式取扱規程"
        color="normal"
      />
      <Spacer h={{ sp: 70, pc: 120 }} />
      <Paragraph>
        株式会社トライアルホールディングスの定款及び株式取扱規程を掲載しております。
      </Paragraph>
      <Spacer h={{ sp: 30, pc: 50 }} />
      <section>
        <PDFList pdfList={pdfList} />
      </section>
    </Layout>
  )
}

ArticlesPage.getLayout = (page: ReactElement) => {
  const breadCrumbs = [
    { name: 'ホーム', path: '/' },
    { name: '株主・投資家向け情報', path: '/ir' },
    { name: '株式情報', path: '/ir/stock' },
    { name: '定款・株式取扱規程', path: '' },
  ]

  return (
    <>
      <Head
        title="定款・株式取扱規程"
        description="トライアルホールディングスの当社の定款及び株式取扱規程を掲載しています。"
        ogp={{ url: 'ir/stock/articles' }}
      />
      <TitleLayout
        title="Investor Relations"
        subTitle="株主・投資家向け情報"
        breadCrumbs={breadCrumbs}
      >
        {page}
      </TitleLayout>
    </>
  )
}
